import { createAction } from '../../Helpers/Action.helpers';
import { STATIC_ACTIONS } from '../../Constants/Actions.constants';
import IWarningKey from '../../Models/Warning.model';

export const requestDismissWarning = (warning: IWarningKey) =>
  createAction({
    name: STATIC_ACTIONS.DISMISS_WARNING,
    payload: { warning },
    type: STATIC_ACTIONS.DISMISS_WARNING,
  });
